import { render, staticRenderFns } from "./EzInfoModal.vue?vue&type=template&id=859b9a1e&scoped=true&"
import script from "./EzInfoModal.vue?vue&type=script&lang=js&"
export * from "./EzInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./EzInfoModal.vue?vue&type=style&index=0&id=859b9a1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859b9a1e",
  null
  
)

export default component.exports